import { Injectable } from '@angular/core';
import { SharedConfig } from '@takectrl-multiapp/svcs-share-config';

@Injectable({
  providedIn: 'root',
})
export class CommunicationService {
  constructor(public sharedConfig: SharedConfig) {}

  makePhoneCall(phoneNumber: string) {
    try {
      // Clean the phone number (remove spaces, dashes, etc.)
      const cleanNumber = phoneNumber.replace(/[^\d+]/g, '');
      
      // Create tel: URI
      const telUri = `tel:${cleanNumber}`;

      // Create a clickable link
      const link = document.createElement('a');
      link.href = telUri;
      link.setAttribute('target', '_self');
      
      // Simulate click
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      console.log('makeCallMethod: Launched dialer!');
      
      return true;
    } catch (error) {
      console.error('makeCallMethod: Error launching dialer', error);
      return false;
    }
  }

  // Alternative implementation that returns a Promise to maintain similar interface
  async makePhoneCallAsync(phoneNumber: string): Promise<boolean> {
    try {
      const cleanNumber = phoneNumber.replace(/[^\d+]/g, '');
      window.location.href = `tel:${cleanNumber}`;
      // or window.open(`tel:${cleanNumber}`, '_self');
      return true;
    } catch (error) {
      console.error('makeCallMethod: Error launching dialer', error);
      return false;
    }
  }
}